export const getOnboardingFormsUrl = () => 'agency/onboarding_forms';

export const getOnboardingFormUrl = (id: string) => `agency/onboarding_forms/${id}`;

export const getOnboardingFormHistoriesUrl = (id: string) => `agency/onboarding_forms/${id}/histories`;

export const getOnboardingFormLoginUrl = () => 'public/onboarding_forms/login';

export const getPublicOnboardingFormUrl = (id: string) => `public/onboarding_forms/${id}`;

export const getPublicCountriesUrl = () => 'public/countries';

export const getPublicStatesUrl = (countryCode: string) => `public/countries/${countryCode}/states`;

export const getPublicAvailableIntegrationsUrl = () => 'public/available_integrations';

export const getValidateIntegrationCredentialsUrl = () => 'public/validate_integration_credentials';

export const getOauthConfigurationUrl = () => 'public/oauth_configuration';

export const getApproveOnboardingFormUrl = (id: string) => `agency/onboarding_forms/${id}/approve`;

export const getPublicOnboardingFormsUrl = () => 'public/onboarding_forms';

export const getBusinessAutocompleteUrl = () => 'public/google_businesses/autocomplete';

export const getBusinessPlaceDetailsUrl = () => 'public/google_businesses/place_details';

export const getCheckoutSessionUrl = () => 'public/onboarding_forms/create_checkout_session';

export const getCreatePromoCodeUrl = (id: string) => `agency/onboarding_forms/${id}/create_promo_code`;

export const getPublicOnboardingPostConfigurationsUrl = () => 'public/onboarding_forms/post_configurations';

export const getAgencyOnboardingPostConfigurationsUrl = () => 'agency/onboarding_forms/post_configurations';
